export class DateRangeDto {
  public date: string[];
}
